import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
    standalone: true,
    selector: 'product-view-tooltip',
    templateUrl: './product-view-tooltip.html',
    styleUrl: './product-view-tooltip.scss',
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewTooltipComponent {
    @Input()
    width?: number;

    @Input()
    fontSize = '16px';

    display = false;

    @Input()
    direction: 'left' | 'right' = 'left';

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    get containerWidth(): string {
        return `${this.width || 206}px`;
    }

    protected toggle(to: boolean): void {
        this.display = to;
        this.detectChanges();
    }

    protected get isRightDirection(): boolean {
        return this.direction === 'right';
    }

    private detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
